<div class="calendar">
  <div class="calendar-header">
    <button (click)="prevMonth()">&lt; Prev </button>
    <h2>{{ currentMonthYear | date: 'MMMM y' }}</h2>
    <button (click)="nextMonth()">&gt; Next</button>
  </div>
  <div class="calendar-days">
    @for (day of days; track day) {
      <div class="day">{{ day }}</div>
    }
  </div>
  <div class="calendar-grid">
    @for (date of dates; track date) {
      @if (date !== null) {
        <div class="calendar-day"
          [ngClass]="{'current-month': date.getMonth() === currentMonth, 'selected-start-date': date.getTime() === startDate?.getTime(), 'selected-end-date': date.getTime() === endDate?.getTime(), 'in-date-range': isDateInRange(date)}"
          (click)="dateClicked(date)">
          {{ date.getDate() }}
        </div>
      }
      @if (date === null) {
        <div class="calendar-day"></div>
      }
    }
  </div>

</div>